import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'medium', className = '', variant = 'primary' }) => {
  let sizeClass = '';
  
  switch(size) {
    case 'small':
    case 'sm':
      sizeClass = 'spinner-sm';
      break;
    case 'large':
    case 'lg':
      sizeClass = 'spinner-lg';
      break;
    default:
      sizeClass = '';
  }
  
  let variantClass = '';
  switch(variant) {
    case 'secondary':
      variantClass = 'spinner-secondary';
      break;
    case 'glow':
      variantClass = 'spinner-glow';
      break;
    default:
      variantClass = 'spinner-primary';
  }
  
  return (
    <div className={`spinner ${sizeClass} ${variantClass} ${className}`}>
      <div className="spinner-inner"></div>
    </div>
  );
};

export default Spinner;